module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('span', {
    staticClass: "box1"
  }, [_vm._v("TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Jordan? Jordan?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Katherine’s voice seemed to come at him from a million miles away. Jordan felt like he was surfacing in a pool after a really deep dive—or maybe like he was coming to after passing out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t . . . faint,” he murmured defensively. “Don’t tell anyone . . . I blacked out . . . like a wuss. It’s just because . . . I’m sick. I have a fever. Mom gave me cold medicine this morning . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jordan could barely squeeze out the word “Mom.” But talking about the medicine gave him an idea.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can cold medicine . . . make someone hallucinate?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He liked this explanation. Probably he’d just had a weird medicine-induced hallucination—that was all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Thinking that gave him the courage to open his eyelids just a crack, just enough to see Katherine hovering over him, her blond ponytail dangling down toward his face. He braced himself for her to make fun of him, as usual. But she seemed to be squinting at him with a look of concern.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you hit your head or anything, falling?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Since when would Katherine care?")]), _vm._v(" Jordan wondered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m fine,” Jordan lied, struggling to prove it by sitting up. But his vision swung out of focus again, and the best he could do was prop himself up on his elbows.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s okay,” Katherine said, sounding much kinder than Jordan would have expected. The type of response he was used to would have been more like "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Don’t you ever dare do anything like that at school! You’d embarrass me!")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is weird for me, too,” Katherine continued, wrinkling up her nose in a wry expression. “And I’ve gotten used to weird things the past few months.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Why would Katherine be any more used to weirdness than Jordan was? Was this a setup for her to say, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("After all, I’ve had to live with weirdo you my whole life?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Katherine just sat there staring at him, a look of deep worry in her blue eyes. This made her look like Mom. And . . . like the girl who’d called Jordan “honey” a few moments ago.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Was that girl maybe Katherine’s mirror image in the ")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("same way that that Jonah kid was Jordan’s? She didn’t look as much like Katherine as Jonah looked like Jordan, but . . .")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Jordan winced, and resisted the urge to look around for all the strange kids, to see if they were still around. He was going to stick to his hallucination theory, and as long as he didn’t see those kids again, he could still believe it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The others went into the kitchen so they wouldn’t freak you out even more when you woke up,” Katherine said, almost as if she knew what he was thinking. Her voice was steady and calm and strangely more mature-sounding than her usual sixth-grade-girl squealing. “I guess you had already blacked out when Jonah explained things. But . . . is it true? You really don’t remember having an identical twin your whole life?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jordan was so indignant he shoved himself the rest of the way up on his arms, so he was almost nose to nose with Katherine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why would I remember having an identical twin my whole life?” he demanded. “I "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("don’t")]), _vm._v(" have an identical twin! I’ve never had an identical twin! It’s just you and me and Mom and Dad—”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("The thought of the Mom-like girl and the Dad-like boy he’d seen—or thought he’d seen—made his voice lose some of its certainty. And his traitorous brain was offering qualifiers: "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("You know, you can’t really be sure about never having ")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("had an identical twin. You’re adopted. And there have been cases of identical twins being separated at birth and raised apart, neither one knowing about the other . . .")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Katherine nodded slowly, still maddeningly calm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The thing is, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("I")]), _vm._v(" remember it being you and me and Jonah my whole life. I remember having both of you around from the very beginning,” she said. “But my brain kind of . . . hiccups or something every time I try to think of you and Jonah together. Jonah says that’s because the two of you grew up in different dimensions of time, and when Jonah fixed time, that smashed the dimensions back together again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jordan waited for Katherine to laugh and squeal, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Ha! Ha! Fooled you! You actually looked like you believed me there for a minute! You thought I would actually talk about different dimensions of time like they were real!")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Katherine’s face stayed serious.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, right, and I guess "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("you")]), _vm._v(" got to be in both our dimensions,” Jordan said, in a way that left two possibilities open. If she was joking, he could claim he was being sarcastic. But if she was telling the truth—or what she believed was the truth—well, he did want to know if she’d been in both dimensions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Exactly,” Katherine said. She smiled, almost as if she was proud of him. “You’re catching on to this stuff a lot faster than Jonah and I did.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Huh?")]), _vm._v(" Jordan thought. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("I’m not catching on to anything.")])])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("But he wasn’t about to let Katherine see that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course you’d get to be in both dimensions,” Jordan taunted, still in a way that could be taken as serious. Or not. “Because you’re so special.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s not the reason,” Katherine said solemnly. It wasn’t like her to pass up the opportunity to say she was better than Jordan. “Just about everybody was in both dimensions. And a third dimension, too, that I don’t even know much about yet. But you and Jonah and, I guess, the other thirty-five kids from the plane—you were the only people who were in just one of the dimensions.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She’d totally lost him now. He really didn’t like thinking about alternate dimensions or identical twins. This was childish, but he wanted to crawl back into bed and have Mom feel his feverish forehead and tell him, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("You’re just having a bad dream because of being sick and taking medicine. None of this is real.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If I go back to my regular dimension of time, will Mom and Dad be their right ages?” he asked crankily.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Katherine bit her lip.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Um . . . I don’t think you "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("can")]), _vm._v(" go back,” she said. “And Mom and Dad being grown-ups again, that was supposed to be fixed already. But, I don’t know, I guess there’s some extra problem—”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("She broke off as a sudden banging sound began at the ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("front door. Someone outside screamed, “Jonah? Katherine? "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Kath-er-iiiine?")]), _vm._v("”")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Katherine scrambled up, ran to the door, and yanked it open.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Chip!” she cried.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A boy with blond curly hair stumbled across the threshold and swept Katherine into the kind of embrace Jordan could never stand to watch in movies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Who do they think they are?")]), _vm._v(" Jordan wondered. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Romeo and Juliet?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jordan had never seen this Chip kid before in his life. But Katherine was acting like she had. She and Chip were acting like they were in love, and they’d been separated for years by some horrible war, or some deadly epidemic no one was supposed to survive, or something else even more tragic and melodramatic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jordan had seen kids at school—mostly eighth graders—act like this over boyfriends or girlfriends just because they hadn’t seen each other overnight. But not Katherine. As far as Jordan knew, Katherine didn’t even have a boyfriend.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Katherine was "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("eleven")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now she and this Chip kid were kissing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Katherine’s older brother, shouldn’t Jordan say something like, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Hey! Hey! Break it up, you two!?")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Before Jordan could say anything, someone else—a dark-haired man—stepped past Katherine and Chip and into the house. He rushed over and crouched down to clap his hand on Jordan’s shoulder.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Jonah—you made it back safely!” the man said. He winced slightly. “Have you . . . have you met Jordan yet?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am Jordan,” Jordan protested.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The man winced again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sorry,” he said. “I’m still getting used to this too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He seemed to be looking Jordan up and down. Defiantly, Jordan stared right back at him. Jordan guessed that Katherine or some of the other girls he knew would think this man was really handsome. But behind his chiseled good looks, the man had an air of exhaustion, or maybe even desperation, as if he’d just survived something traumatic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Or maybe was still in the middle of something traumatic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can see now that you’re not Jonah,” the man said, very seriously. Somehow Jordan could tell that the man was talking about more than just the placement of a chin dimple. Jordan felt almost insulted, as if the man were saying Jordan didn’t measure up. “It’s just . . . the last time I saw "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("you")]), _vm._v(", you were a year and a half old.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Jordan realized that, on top of all the other oddities ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("going on this morning, it was also strange that this man Jordan had never seen before—or didn’t remember ever seeing before—had just walked into Jordan’s house.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Uh, do my parents know you?” Jordan asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Jonah and Katherine do,” the man said. He stuck out his hand. “I’m JB.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jordan was saved from having to shake JB’s hand because Katherine came bouncing over just then, pulling Chip along behind her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s good to see you, too, JB!” she exclaimed, dipping down to give him a rough hug, as if he were some favorite uncle. Which, of course, he wasn’t. “I’m so glad Chip and the other kids are okay. Are you here to help Mom and Dad and Angela?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("JB cut his gaze back and forth between Jordan and Katherine and Chip.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That situation is . . . complicated,” he said. “Maybe we should leave that subject for later?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jordan felt like he did when Mom and Dad spoke in code language because they didn’t want him and Katherine to know something. They’d kind of stopped doing that once he and Katherine hit middle school, because it mostly stopped working.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("But now this guy is acting like he’s got secrets I’m not allowed to know about but Katherine is?")]), _vm._v(" Jordan thought indignantly.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("“Oh, hey, Jordan,” Katherine said. “Aren’t you sick?”")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Um—” Jordan began.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And, like, hallucinating or something?” Katherine continued. “And didn’t you black out a minute ago? Don’t you think you should just go back to bed?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And then everything will be fine when you wake up again,” JB said, too heartily.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, right,” Chip agreed. “That’s how these things work. When you’re sick, I mean.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("JB was still crouched in front of Jordan. Katherine stood right behind the man, her hand still on his shoulder, her arm still linked through Chip’s. It was like the three of them were a team—a team united against Jordan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jordan wanted to say, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("You’re sick too, Katherine. Don’t you think")]), _vm._v(" you "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("should go back to bed? After you send these strangers away? Don’t you think Mom would be mad that you let them into the house?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But his mind kept . . . what had Katherine called it? “Hiccupping”? Jumping around, anyway . . . over certain details. Before he’d come downstairs, hadn’t he believed that Katherine was home sick too? Before he saw the oddly young versions of his parents, hadn’t he thought that Mom was working from home today, to take care of him and his sister? Why couldn’t he remember, one way or the other?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jordan rubbed his forehead.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("“Why do I feel like . . . ,” he began. But he saw how JB, Katherine, and Chip instantly drew closer, instantly began darting glances at one another, as if they needed to work together to handle whatever Jordan was going to ask.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("How could I believe anything any of them might tell me?")]), _vm._v(" Jordan wondered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe I will go back to bed,” Jordan said. “I feel kind of weird.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Great idea!” JB said in a totally fake voice, acting like Jordan was some kind of genius just for repeating the same plan Katherine had suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Hadn’t")]), _vm._v(" she just suggested that? Or was Jordan a lot sicker and more confused than he thought?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jordan turned and walked toward the stairs. He kept his head down as he climbed them, and acted like he felt too awful to ask any more questions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He had to act like that. He had to pretend he wasn’t curious.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Because he was totally going to sneak back downstairs and listen to everything the others said as soon as they thought he was gone.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-726606ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 66
// module chunks = 0